import React from 'react';
import {cloneDeep} from 'lodash';
import history from '../../../../history';
import { PanelGroup, Panel } from '../../compat/PanelCompat';
import PackageUsers from '../../packageUsers';
import CordellEstimatorZones from './cordellEstimatorZones';
import UsersActive from '../../../../image/Icons/Users-active.svg';
import ZonesDefault from '../../../../image/Icons/Zones-default.svg';
import ZonesActive from '../../../../image/Icons/Zones-active.svg';
import ZonesDeactive from '../../../../image/Icons/Zones-inactive.svg';
import { ToastStore } from '../../../../components/ToastStore';

export default class CordellEstimatorProductPackageConfiguration extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);

    if (this.props.onSelectingUser !== undefined) {
      this.onSelectingUser = this.props.onSelectingUser.bind(this);
    }
    this.onUserClickAction = this.onUserClickAction.bind(this);

    if (this.props.onSelectingGeography !== undefined) {
      this.onSelectingGeography = this.props.onSelectingGeography.bind(this);
    }
    this.onGeographyClickAction = this.onGeographyClickAction.bind(this);
    // commented out as the part it's used in is also commented out
    // if (this.props.onSelectingAddons !== undefined) {
    //   this.onSelectingAddons = this.props.onSelectingAddons.bind(this);
    // }

    this.selectCategory = this.selectCategory.bind(this);
    this.selectedGeographyState = this.selectedGeographyState.bind(this);
    this.selectSingleState = this.selectSingleState.bind(this);

    this.state = {
      mobile: false,
      activeKey: '1',
      basePrice: 0.0,
      option1: null,
      option2: null,
      option3: null,
      geographyStatesSection: [],
      selectedZone: 1,
      stateError: null,
      categories: []
    };
  }

  /* istanbul ignore next */
  componentDidMount() {
    this.selectCategory();
    if (/Android|webOS|iPhone|iPod|ipad|BlackBerry/i.test(navigator.userAgent)) {
      this.setState({
        mobile: true
      });
    }
  }

  /* istanbul ignore next */
  handleSelect(activeKey) {
    this.setState({ activeKey });
  }

  /* istanbul ignore next */
  onCategoryClickAction() {
    this.setState({
      activeKey: '2'
    });
  }

  /* istanbul ignore next */
  onUserClickAction() {
    this.setState({
      activeKey: '3'
    });
  }

  /* istanbul ignore next */
  onGeographyClickAction() {
    this.setState({
      activeKey: '4'
    });
  }

  /* istanbul ignore next */
  setZonesPricing() {
    let geographyStatesSection = [];
    let geographyStates = [];
    let geography = this.props.productPackageConfig.packages[this.props.packageKey].geography;

    geographyStates = geography.states;

    let statePrice;
    for (let index = 0; index < geography.maximumStates; index++) {
      let packagePrice = 0.0;
      packagePrice = packagePrice + parseFloat(geography.basePrice[index], 10.0);
      statePrice = Math.abs(this.state.basePrice - packagePrice).toFixed(2);
      geographyStatesSection.push({
        id: parseInt(index, 10) + 1,
        price: `+$${statePrice}`,
        state: `${parseInt(index, 10) + 1} State/Territory`,
        total: packagePrice
      });
    }

    this.setState({
      geographyStatesSection: geographyStatesSection,
      geographyStates: geographyStates
    });

    let stateId = 1;

    if (this.props.productPackageDefaultConfig.configuration.geography.states !== null) {
      let option1 = null,
        option2 = null,
        option3 = null;

      let numbOfStates =
        this.props.productPackageDefaultConfig.configuration.geography.states.length;
      if (numbOfStates === 1) {
        option1 = this.props.productPackageDefaultConfig.configuration.geography.states[0];
      }
      if (numbOfStates === 2) {
        stateId = 2;
        option2 = this.props.productPackageDefaultConfig.configuration.geography.states[0];
        option3 = this.props.productPackageDefaultConfig.configuration.geography.states[1];
      }

      this.setState({
        option1: option1,
        option2: option2,
        option3: option3
      });
    }

    for (let state of geographyStatesSection) {
      if (state.id === stateId) {
        state.total = parseFloat(state.total);
        this.selectedGeographyState(
          geographyStatesSection,
          state,
          state.id,
          false
        );
      }
    }
  }

  /* istanbul ignore next */
  selectSingleState(selectedState, id) {
    let option1 = cloneDeep(this.state.option1);
    let option2 = cloneDeep(this.state.option2);
    let option3 = cloneDeep(this.state.option3);
    let stateError = cloneDeep(this.state.stateError);
    if (id === 1) {
      option1 = selectedState;
      option2 = null;
      option3 = null;
    } else if (id === 2) {
      option1 = null;
      option2 = selectedState;
    } else if (id === 3) {
      option1 = null;
      option3 = selectedState;
    }

    if (option2 !== null && option3 !== null) {
      if (option2 === option3) {
        stateError = 2;
        ToastStore.error('You cannot select the state you have previously selected');
      } else {
        stateError = null;
        this.props.onSelectingGeography([option2, option3], false);
        // this.onGeographyClickAction()
      }
    } else if (option1 !== null) {
      stateError = null;
      this.props.onSelectingGeography([option1], false);
      // this.onGeographyClickAction()
    }

    this.setState({
      option1: option1,
      option2: option2,
      option3: option3,
      stateError: stateError
    });
  }

  /* istanbul ignore next */
  selectedGeographyState(geographyStatesSection, section, index, clickAction) {
    this.setState({
      selectedZone: section.id
    });
    if (section.id === 0) {
      this.props.onSelectingGeography(null, true);
      if (clickAction) {
        this.onGeographyClickAction();
      }
      this.setState({
        option1: null,
        option2: null,
        option3: null
      });
    }
    for (let geographyStatesSectionItem of geographyStatesSection) {
      let price = section.total - geographyStatesSectionItem.total;
      if (price === 0) {
        geographyStatesSectionItem.price = 'Selected';
      } else if (price > 0) {
        geographyStatesSectionItem.price = `-$${Math.abs(price).toFixed(2)}`;
      } else if (price < 0) {
        geographyStatesSectionItem.price = `+$${Math.abs(price).toFixed(2)}`;
      }
    }

    this.setState({
      geographyStatesSection: geographyStatesSection
    });
  }

  /* istanbul ignore next */
  selectCategory(categoryKey) {
    let category = this.props.productPackageDefaultConfig.configuration.category;
    let residential,
      basePrice = 0.0;
    let categories = [];

    //Default and fixed category
    residential =
      this.props.productPackageConfig.packages[this.props.packageKey].geography.basePrice[0];
    basePrice = basePrice + parseFloat(residential, 10);
    categories.push('residential');

    this.setState(
      {
        basePrice: basePrice,
        categories: categories
      },
      () => {
        this.setZonesPricing();
      }
    );
    if (categoryKey) {
      this.props.setCategory(categoryKey);
    }
  }

  render(props) {
    let zones = 'active';
    if (this.props.productPackageDefaultConfig.configuration.geography.states === null) {
      if (this.state.activeKey !== '3') {
        zones = 'inactive';
      } else {
        zones = 'default';
      }
    }

    let classNames = require('classnames');
    let zonesTileClass = classNames({
      'white-bg': zones !== 'inactive',
      'off-white-bg': zones === 'inactive'
    });

    return (
      <div>
        <div className='row no-margin'>
          <div className='col-sm-12'>
            <div className='row'>
              <div className='back-btn' onClick={history.goBack}>
                {' '}
                &lt; Back{' '}
              </div>
              <hr />
            </div>
            <div className='row'>
              <div className='section-no-pad-title text-center'>Customise Your Subscription</div>
            </div>
          </div>
        </div>
        <div className='row white-bg padding-20 body'>
          <div className='col-sm-12 no-padding'>
            <PanelGroup
              accordion
              id='product-config-accordion'
              activeKey={this.state.activeKey}
              onSelect={this.handleSelect}
            >
              <Panel eventKey='1'>
                <Panel.Heading className='white-bg'>
                  <Panel.Title toggle>
                    <div type='button' className='row panel-title panel-button no-margin'>
                      <div className='col-xs-7 text-left text-success no-padding'>
                        <img src={UsersActive} alt='' className='margin-right-5' />
                        Category
                      </div>
                      <div className='col-xs-5 text-right text-success no-padding'>
                        <span style={{"lineHeight": "30px"}}>Residential &nbsp;</span>
                        {this.state.activeKey !== '1' && (
                          <span className='panel-dropdown-icon carat-down' aria-hidden='true'></span>
                        )}
                        {this.state.activeKey === '1' && (
                          <span className='panel-dropdown-icon carat-up' aria-hidden='true'></span>
                        )}
                      </div>
                    </div>
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  <div className='panel-body-spacing'>
                    <div className='alert alert-success'>
                      <div className='row'>
                        <div className='col-xs-12'>
                          Residential
                          <div id='config-category-residential' className='row no-margin footnote-text'>
                            {
                              this.props.productPackageConfig.packages[this.props.packageKey]
                                .features.categories.residential.sub_text_1
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    type='submit'
                    className='btn btn-primary float-right btn-continue margin-bottom-10'
                    onClick={() => {
                      this.onCategoryClickAction();
                    }}
                  >
                    Next
                  </button>
                </Panel.Body>
              </Panel>
              <Panel eventKey='2'>
                <Panel.Heading className='white-bg'>
                  <Panel.Title toggle>
                    <div type='button' className='row panel-title panel-button no-margin'>
                      <div className='col-xs-7 text-left text-success no-padding'>
                        <img src={UsersActive} alt='' className='margin-right-5' />
                        Users
                      </div>
                      <div className='col-xs-5 text-right text-success no-padding'>
                        {this.props.productPackageDefaultConfig.configuration.numberOfUsers !==
                          null && (
                          <span style={{"lineHeight": "30px"}}>
                            {this.props.productPackageDefaultConfig.configuration.numberOfUsers}{' '}
                            {this.props.productPackageDefaultConfig.configuration.numberOfUsers ===
                            1
                              ? 'User'
                              : 'Users'}{' '}
                          </span>
                        )}
                        {this.state.activeKey !== '2' && (
                          <span className='panel-dropdown-icon carat-down' aria-hidden='true'></span>
                        )}
                        {this.state.activeKey === '2' && (
                          <span className='panel-dropdown-icon carat-up' aria-hidden='true'></span>
                        )}
                      </div>
                    </div>
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  <PackageUsers
                    users={this.props.productPackageConfig.packages[this.props.packageKey].users}
                    selectedUser={
                      this.props.productPackageDefaultConfig.configuration.numberOfUsers
                    }
                    onSelectingUser={this.onSelectingUser}
                    onUserClickAction={this.onUserClickAction}
                  />
                </Panel.Body>
              </Panel>
              <Panel eventKey='3'>
                <Panel.Heading className={zonesTileClass}>
                  <Panel.Title toggle>
                    <div type='button' className='row panel-title panel-button no-margin'>
                      <div className='col-xs-8 text-left no-padding'>
                        {zones === 'default' && (
                          <span>
                            <img src={ZonesDefault} alt='' className='margin-right-5' />
                            <span>Zones</span>
                          </span>
                        )}
                        {zones === 'active' && (
                          <span>
                            <img src={ZonesActive} alt='' className='margin-right-5' />
                            <span className='text-success'>Zones</span>
                          </span>
                        )}
                        {zones === 'inactive' && (
                          <span>
                            <img src={ZonesDeactive} alt='' className='margin-right-5' />
                            <span className='tan-text'>Zones</span>
                          </span>
                        )}
                      </div>
                      <div className='col-xs-4 text-right no-padding'>
                        <span>
                          {this.props.productPackageDefaultConfig.configuration.geography.states !=
                            null &&
                            this.props.productPackageDefaultConfig.configuration.geography.states.map(
                              function (state, index) {
                                return (
                                  <span style={{"lineHeight": "30px"}} className='text-success' key={index}>
                                    {state}.{' '}
                                  </span>
                                );
                              }
                            )}
                        </span>
                        {this.state.activeKey !== '3' && zones === 'default' && (
                          <span className='panel-dropdown-icon carat-down' aria-hidden='true'></span>
                        )}
                        {this.state.activeKey === '3' && zones === 'default' && (
                          <span className='panel-dropdown-icon carat-up' aria-hidden='true'></span>
                        )}
                        {this.state.activeKey !== '3' && zones === 'active' && (
                          <span
                            className='panel-dropdown-icon carat-down text-success'
                            aria-hidden='true'
                          ></span>
                        )}
                        {this.state.activeKey === '3' && zones === 'active' && (
                          <span className='panel-dropdown-icon carat-up text-success' aria-hidden='true'></span>
                        )}
                        {this.state.activeKey !== '3' && zones === 'inactive' && (
                          <span className='panel-dropdown-icon carat-down tan-text' aria-hidden='true'></span>
                        )}
                      </div>
                    </div>
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  <CordellEstimatorZones
                    selectedGeography={
                      this.props.productPackageDefaultConfig.configuration.geography
                    }
                    selectedPackage={this.props.productPackageDefaultConfig.configuration.package}
                    onSelectingGeography={this.onSelectingGeography}
                    packageBasePrice={this.state.basePrice}
                    option1={this.state.option1}
                    option2={this.state.option2}
                    option3={this.state.option3}
                    geographyStatesSection={this.state.geographyStatesSection}
                    geographyStates={this.state.geographyStates}
                    selectedZone={this.state.selectedZone}
                    stateError={this.state.stateError}
                    selectedGeographyState={this.selectedGeographyState}
                    selectSingleState={this.selectSingleState}
                  />
                </Panel.Body>
              </Panel>
              {
                //   this.props.productPackageConfig.packages[this.props.packageKey].addons && this.props.productPackageConfig.packages[this.props.packageKey].addons.length > 0 &&
                // <Panel eventKey="4">
                //   <Panel.Heading className={addonsTileClass}>
                //     <Panel.Title toggle>
                //       <div type="button" className="row panel-title panel-button no-margin">
                //         <div className="col-xs-8 text-left font-14 no-padding">
                //           {this.props.productPackageDefaultConfig.configuration.addons.length===0 &&
                //             this.state.activeKey==='4' &&
                //             <span>
                //               <img src={AddonsDefault} alt="" className="margin-right-5"/>
                //               <span>Add-Ons</span>
                //             </span>
                //           }
                //           {this.props.productPackageDefaultConfig.configuration.addons.length>0 &&
                //             <span>
                //               <img src={AddonsActive} alt="" className="margin-right-5"/>
                //               <span className="text-success">Add-Ons</span>
                //             </span>
                //           }
                //           {this.props.productPackageDefaultConfig.configuration.addons.length===0 &&
                //             this.state.activeKey !== '4' &&
                //             <span>
                //               <img src={AddonsInactive} alt="" className="margin-right-5"/>
                //               <span className="tan-text">Add-Ons</span>
                //             </span>
                //           }
                //         </div>
                //         <div className="col-xs-4 text-right no-padding font-14">
                //             {
                //               this.props.productPackageDefaultConfig.configuration.addons.length>0 &&
                //               <div className="text-success">
                //                 {this.props.productPackageDefaultConfig.configuration.addons[0]}
                //               </div>
                //             }
                //             {
                //               this.props.productPackageDefaultConfig.configuration.addons.length>1 &&
                //               <small className="text-success margin-right-5">
                //                 +{this.props.productPackageDefaultConfig.configuration.addons.length - 1} more
                //               </small>
                //             }
                //           {this.state.activeKey!=='4' &&
                //            this.props.productPackageDefaultConfig.configuration.addons.length===0 &&
                //             <span className="carat-up tan-text" aria-hidden="true"></span>
                //           }
                //           {this.state.activeKey==='4' && this.props.productPackageDefaultConfig.configuration.addons.length===0 &&
                //             <span className="carat-down" aria-hidden="true"></span>
                //           }
                //           {this.state.activeKey!=='4' && this.props.productPackageDefaultConfig.configuration.addons.length>0 &&
                //             <span className="carat-up text-success" aria-hidden="true"></span>
                //           }
                //           {this.state.activeKey==='4' && this.props.productPackageDefaultConfig.configuration.addons.length>0 &&
                //             <span className="carat-down text-success" aria-hidden="true"></span>
                //           }
                //         </div>
                //       </div>
                //     </Panel.Title>
                //   </Panel.Heading>
                //   <Panel.Body collapsible>
                //     <PackageAddons
                //       addons={this.props.productPackageConfig.packages[this.props.packageKey].addons}
                //       selectedAddons={this.props.productPackageDefaultConfig.configuration.addons}
                //       onSelectingAddons = {this.onSelectingAddons}
                //     />
                //   </Panel.Body>
                // </Panel>
              }
            </PanelGroup>
          </div>
        </div>
      </div>
    );
  }
}
